import { ComponentProps } from "."
import { StyledBigNumber } from "./styled"

const BigNumber = ({ number }: ComponentProps) => (
  <StyledBigNumber>{number?.toLocaleString("en-US")}</StyledBigNumber>
)

export default BigNumber
